module.exports = __webpack_public_path__ + "img/1.972a3bc4.png";